import Entity from 'helpers/entity'

const orgInactiveNotificationsEntity = new Entity({
  orderable: true,
  name: 'orgInactiveNotifications',
  pending: ['getAll', 'post', 'get', 'patch', 'delete', 'postOrder', 'postRepeatDay'],
  loaded: ['getAll'],
  additionalInitialState: {
    repeatDay: null,
    sort: {
      by: 'order',
      desc: false,
    },
    beforeCreateId: null,
    idToDelete: null,
  },
  sortable: true,
  sortFields: {
    order: 'number',
  },
})

export default orgInactiveNotificationsEntity
